import React from 'react';
import './Loader.css';

const Loader = ({ loading }) => {
  if (!loading) return null;
  return <div className="loader"></div>;
};

export default Loader;
